import React from 'react';
import './label.css';

const Label = (props) => {
    return (
        <div className='labelt'>{props.labelt}</div>
    );
}

export default Label;